module.exports = "/images/blister-3.png";